"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.canIContinue = exports.canICancelProcedure = exports.canIResendProcedure = exports.convertTabuServiceToTabuSmartService = exports.addTabuServiceNameToContainer = exports.addTabuServiceDescriptionToContainer = exports.getTabuServiceByStringId = exports.getTabuServiceById = exports.ValidateArrayErrorResponse = exports.validateProperty = exports.checkForExistingTWIC = exports.checkForExistingPendingProcedure = exports.HistoryProcedureProxyIdFilter = exports.HistoryProcedurePendingStatusFilter = exports.HistoryProcedurePropertyFilter = exports.HistoryProcedureIdFilter = exports.UpdateTabuSmartServiceInfo = exports.getAPUrl = exports.tabuProcedureIdString = exports.tabuRequestIcon = exports.tabuRequestStatus = exports.isSameRequest = void 0;
var entity_1 = require("./entity");
var core_1 = require("@eres/core");
var api_1 = require("./api");
var TabuProcedures_1 = require("./TabuProcedures");
var utils_1 = require("../utils");
var utils_config_1 = require("./utils-config");
function isSameRequest(req1, req2) {
    return (req1.ProcedureNumber === req2.ProcedureNumber &&
        req1.ProcedureYear === req2.ProcedureYear &&
        req1.ProcedureId === req2.ProcedureId);
}
exports.isSameRequest = isSameRequest;
function tabuRequestStatus(statusId) {
    switch (statusId) {
        case entity_1.TabuRequestStatusType.ENTERED:
            return "req_entered";
        case entity_1.TabuRequestStatusType.PENDING_PAYMENT:
            return "req_pending_payment";
        case entity_1.TabuRequestStatusType.PAID:
            return "req_paid";
        case entity_1.TabuRequestStatusType.COMPLETED:
            return "req_completed";
        case entity_1.TabuRequestStatusType.REJECTED:
            return "req_rejected";
        case entity_1.TabuRequestStatusType.CANCELLED:
            return "req_cancelled";
        case entity_1.TabuRequestStatusType.UNDER_AUDIT:
            return "req_under_audit";
        default:
            return "req_entered";
    }
}
exports.tabuRequestStatus = tabuRequestStatus;
function tabuRequestIcon(id) {
    switch (id) {
        case entity_1.ProcedureIDs.TO_WHOM_CONCERN:
            return "twimc";
        case entity_1.ProcedureIDs.PROPERTY_DETAIL_CERT:
            return "property_detail_cert";
        case entity_1.ProcedureIDs.SITE_PLAN:
            return "site_plan";
        case entity_1.ProcedureIDs.ELECTRONIC_TITLE_DEED:
            return "electronic_title_deed";
        case entity_1.ProcedureIDs.PROPERTY_VALUATION:
            return "prop_valuation";
        case entity_1.ProcedureIDs.LOSS_CERTIFICATE:
            return "loss_cert";
        case entity_1.ProcedureIDs.INTERNAL_PROPERTY_VALUATION:
            return "iprop_valuation";
        case entity_1.ProcedureIDs.BCS_RE_CLASSIFICATION:
            return "bcs_re_classification";
        case entity_1.ProcedureIDs.OWNERSHIP_CHANGE:
            return "ownership_change";
        case entity_1.ProcedureIDs.PROPERTY_CUT_OFF:
            return "property_cut_off";
        case entity_1.ProcedureIDs.DELAYED_PROPERTY_CUT_OFF:
            return "delayed_property_cut_off";
        case entity_1.ProcedureIDs.PROPERTY_ANNEX:
            return "property_annex";
        case entity_1.ProcedureIDs.DELAYED_PROPERTY_ANNEX:
            return "delayed_property_annex";
        case entity_1.ProcedureIDs.CONVERT_TO_FREEHOLD:
            return "nfh_fh";
        default:
            return "";
    }
}
exports.tabuRequestIcon = tabuRequestIcon;
function tabuProcedureIdString(id) {
    switch (id) {
        case entity_1.ProcedureIDs.TO_WHOM_CONCERN:
            return "twimc";
        case entity_1.ProcedureIDs.PROPERTY_DETAIL_CERT:
            return "ptwimc";
        case entity_1.ProcedureIDs.SITE_PLAN:
            return "site_plan";
        case entity_1.ProcedureIDs.ELECTRONIC_TITLE_DEED:
            return "electronic_title_deed";
        case entity_1.ProcedureIDs.PROPERTY_VALUATION:
            return "prop_valuation";
        case entity_1.ProcedureIDs.LOSS_CERTIFICATE:
            return "loss_cert";
        case entity_1.ProcedureIDs.INTERNAL_PROPERTY_VALUATION:
            return "iprop_valuation";
        case entity_1.ProcedureIDs.BCS_RE_CLASSIFICATION:
            return "bcs_reclassification";
        case entity_1.ProcedureIDs.OWNERSHIP_CHANGE:
            return "ownership_change";
        case entity_1.ProcedureIDs.PROPERTY_CUT_OFF:
            return "property_cut_off";
        case entity_1.ProcedureIDs.DELAYED_PROPERTY_CUT_OFF:
            return "delayed_property_cut_off";
        case entity_1.ProcedureIDs.PROPERTY_ANNEX:
            return "property_annex";
        case entity_1.ProcedureIDs.DELAYED_PROPERTY_ANNEX:
            return "delayed_property_annex";
        case entity_1.ProcedureIDs.CONVERT_TO_FREEHOLD:
            return "nfh_fh";
        default:
            return "";
    }
}
exports.tabuProcedureIdString = tabuProcedureIdString;
function getAPUrl(pID, pYear, pNumber, propertyId) {
    return "http://ameentasjeel.ae/PrintSitePlan/ShowPrintSitePlan.aspx?ID=" + pID + "&Year=" + pYear + "&No=" + pNumber + "&Prop=" + propertyId;
}
exports.getAPUrl = getAPUrl;
function UpdateTabuSmartServiceInfo(procedureInfo, names, description) {
    var nk = core_1.LocaleUtil.getLocalValue(procedureInfo.Name, "en");
    if (names[nk] != null) {
        procedureInfo.Name = names[nk];
    }
    var dk = core_1.LocaleUtil.getLocalValue(procedureInfo.Description, "en");
    if (description[dk] != null) {
        procedureInfo.Description = description[dk];
    }
}
exports.UpdateTabuSmartServiceInfo = UpdateTabuSmartServiceInfo;
function HistoryProcedureIdFilter(id) {
    return function (x) {
        var _a;
        var pid = x.ProcedureId ? x.ProcedureId + "" : ((_a = x.Procedure) === null || _a === void 0 ? void 0 : _a.ID) + "";
        return pid === id + "";
    };
}
exports.HistoryProcedureIdFilter = HistoryProcedureIdFilter;
function HistoryProcedurePropertyFilter(propertyId, propertyTypeId) {
    var ppId = propertyId + "";
    var ppTId = propertyTypeId + "";
    return function (x) {
        var pid = x.PropertyId + "";
        var pTid = x.PropertyTypeId + "";
        return pid === ppId && pTid === ppTId;
    };
}
exports.HistoryProcedurePropertyFilter = HistoryProcedurePropertyFilter;
function HistoryProcedurePendingStatusFilter() {
    return function (x) {
        var sid = x.RequestStatusId;
        return !(sid === entity_1.TabuRequestStatusType.COMPLETED
            || sid === entity_1.TabuRequestStatusType.CANCELLED
            || sid === entity_1.TabuRequestStatusType.REJECTED);
    };
}
exports.HistoryProcedurePendingStatusFilter = HistoryProcedurePendingStatusFilter;
function HistoryProcedureProxyIdFilter(proxyId) {
    if (proxyId != null) {
        return function (x) {
            var sid = x.CompanyParticipantId;
            return sid + "" === proxyId + "";
        };
    }
    else {
        return function (x) {
            var sid = x.CompanyParticipantId;
            return sid == null || sid === "" || sid === -1;
        };
    }
}
exports.HistoryProcedureProxyIdFilter = HistoryProcedureProxyIdFilter;
function checkForExistingPendingProcedure(participantID, procedureId, propertyId, propertyTypeId, stringContainer, proxyId) {
    return (0, api_1.getRequests)(participantID)
        .then(function (response) {
        var requests = response.Response;
        requests = requests === null || requests === void 0 ? void 0 : requests.filter(HistoryProcedureIdFilter(procedureId));
        requests = requests === null || requests === void 0 ? void 0 : requests.filter(HistoryProcedurePendingStatusFilter());
        requests = requests === null || requests === void 0 ? void 0 : requests.filter(HistoryProcedureProxyIdFilter(proxyId));
        if (propertyTypeId) {
            requests = requests === null || requests === void 0 ? void 0 : requests.filter(HistoryProcedurePropertyFilter(propertyId, propertyTypeId));
        }
        if (requests && requests.length > 0) {
            var fr = requests[0];
            if (fr.RequestStatusId === entity_1.TabuRequestStatusType.PENDING_PAYMENT) {
                return Promise.reject((0, utils_1.MakeSMessageError)(stringContainer.not_paid_tabu_req, fr));
            }
            else if (fr.RequestStatusId === entity_1.TabuRequestStatusType.PAID) {
                return Promise.reject((0, utils_1.MakeSMessageError)(stringContainer.paid_tabu_req, fr));
            }
            return Promise.reject((0, utils_1.MakeSMessageError)(stringContainer.duplicate_tabu_error_msg, requests));
        }
        else {
            return Promise.resolve(true);
        }
    });
}
exports.checkForExistingPendingProcedure = checkForExistingPendingProcedure;
function checkForExistingTWIC(participantID, stringContainer, proxyId) {
    return checkForExistingPendingProcedure(participantID, entity_1.ProcedureIDs.TO_WHOM_CONCERN, 0, 0, stringContainer, proxyId);
}
exports.checkForExistingTWIC = checkForExistingTWIC;
function validateProperty(response) {
    if (response == undefined)
        return Promise.reject("Empty response");
    if (response.Response == null || response.Response.length === 0) {
        return Promise.resolve(true);
    }
    else {
        var e = response.Response;
        var message = e.reduce(function (previousValue, currentValue) {
            if (currentValue.Name) {
                return previousValue + "\n" + core_1.LocaleUtil.getLocalValue(currentValue.Name);
            }
            else {
                return previousValue + "\n" + currentValue.Value;
            }
        }, "");
        return Promise.reject(message.trim());
    }
}
exports.validateProperty = validateProperty;
function ValidateArrayErrorResponse(response) {
    if (!response)
        throw new Error("Empty Response");
    if (response.hasOwnProperty("Response") && response.Response) {
        var errors = response.Response;
        if (errors && Array.isArray(errors) && errors.length > 0) {
            var message = "";
            for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                var error = errors_1[_i];
                var msg = core_1.LocaleUtil.getLocalValue({
                    ar: error.ErrorMessageAr,
                    en: error.ErrorMessage,
                });
                if (msg != undefined) {
                    message += "\n" + msg;
                }
                else {
                    message += "\n" + "Error :" + error.ValidationType;
                }
            }
            throw new Error(message);
        }
    }
    if (response.hasOwnProperty("Code")) {
        var code = response.Code;
        if (code + "" !== "0") {
            throw new Error(response.Message || "Error Code" + code);
        }
    }
    return Promise.resolve(response.Response);
}
exports.ValidateArrayErrorResponse = ValidateArrayErrorResponse;
function getTabuServiceById(id) {
    var qId = id + "";
    return TabuProcedures_1.AllTabuProcedures.find(function (x) { return x.Id + "" === qId; });
}
exports.getTabuServiceById = getTabuServiceById;
function getTabuServiceByStringId(id) {
    return TabuProcedures_1.AllTabuProcedures.find(function (x) { return tabuProcedureIdString(x.Id) === id; });
}
exports.getTabuServiceByStringId = getTabuServiceByStringId;
function addTabuServiceDescriptionToContainer(container, svc) {
    if (container) {
        var id = tabuProcedureIdString(svc.Id);
        if (container[id])
            return;
        container[id] = svc.Description;
    }
}
exports.addTabuServiceDescriptionToContainer = addTabuServiceDescriptionToContainer;
function addTabuServiceNameToContainer(container, svc) {
    if (container) {
        var id = tabuProcedureIdString(svc.Id);
        if (container[id])
            return;
        container[id] = svc.Name;
    }
}
exports.addTabuServiceNameToContainer = addTabuServiceNameToContainer;
function convertTabuServiceToTabuSmartService(ts) {
    return getTabuServiceById(ts.ID);
}
exports.convertTabuServiceToTabuSmartService = convertTabuServiceToTabuSmartService;
function canIResendProcedure(pd) {
    if (pd.TabuRequest.RequestStatusId === entity_1.TabuRequestStatusType.REJECTED) {
        var pId = pd.Procedure.ID;
        return utils_config_1.TabuUtilsConfig.resendAllowedProcedures.indexOf(pId) !== -1;
    }
    return false;
}
exports.canIResendProcedure = canIResendProcedure;
if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) !== "test") {
    if (((_b = utils_config_1.TabuUtilsConfig.resendAllowedProcedures) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        // tslint:disable-next-line:no-console
        console.error("TabuUtilsConfig.resendAllowedProcedures is not configured or empty", (_c = process === null || process === void 0 ? void 0 : process.env) === null || _c === void 0 ? void 0 : _c.NODE_ENV);
    }
}
function canICancelProcedure(pd) {
    var pId = pd.Procedure.ID;
    switch (pd.TabuRequest.RequestStatusId) {
        case entity_1.TabuRequestStatusType.ENTERED:
        case entity_1.TabuRequestStatusType.REJECTED:
            return true;
        case entity_1.TabuRequestStatusType.PENDING_PAYMENT:
            return (pId === entity_1.ProcedureIDs.TO_WHOM_CONCERN || pId === entity_1.ProcedureIDs.PROPERTY_CUT_OFF ||
                pId === entity_1.ProcedureIDs.DELAYED_PROPERTY_CUT_OFF || pId === entity_1.ProcedureIDs.PROPERTY_ANNEX ||
                pId === entity_1.ProcedureIDs.DELAYED_PROPERTY_ANNEX);
    }
    return false;
}
exports.canICancelProcedure = canICancelProcedure;
function canIContinue(pd) {
    var pId = pd.Procedure.ID;
    switch (pd.TabuRequest.RequestStatusId) {
        case entity_1.TabuRequestStatusType.ENTERED:
            return pId !== entity_1.ProcedureIDs.INTERNAL_PROPERTY_VALUATION;
        case entity_1.TabuRequestStatusType.PENDING_PAYMENT:
            return true;
    }
    return false;
}
exports.canIContinue = canIContinue;
